import { render, staticRenderFns } from "./ContactME.vue?vue&type=template&id=0b270e6c&scoped=true"
import script from "./ContactME.vue?vue&type=script&lang=js"
export * from "./ContactME.vue?vue&type=script&lang=js"
import style0 from "./ContactME.vue?vue&type=style&index=0&id=0b270e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b270e6c",
  null
  
)

export default component.exports